import { render, staticRenderFns } from "./DefaultChart.vue?vue&type=template&id=580ec98a&scoped=true&"
import script from "./DefaultChart.vue?vue&type=script&lang=js&"
export * from "./DefaultChart.vue?vue&type=script&lang=js&"
import style0 from "./DefaultChart.vue?vue&type=style&index=0&id=580ec98a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580ec98a",
  null
  
)

export default component.exports